<template lang="pug">
    game-preview-settings(v-if="settings")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ settings.amountOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_dayOfWeek') }}
        game-preview-setting(v-if="settings.timeForAnswer != '-1'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
            span(slot="value")
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="settings.timeLimit > 0")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ settings.timeLimit }}
        template
            game-preview-setting
                span(slot="name") {{ 'Случайная дата' }}
                span(slot="value", v-if="settings.randomDate")
                    | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
                span(slot="value", v-else)
                    | {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
</template>

<script>
    import preview from '../../../utils/multiplication-and-division/preview';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [preview],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {},
    };
</script>
